<template>
    <div>
        <div class="mt-5 text-gray-400">
            <p>{{display}}</p>
        </div>
        <div v-for="result in results" :key="result" class="bg-gray-100 p-3 rounded ">
            <div class="flex p-2">
                <i class="fa fa-dot text-green-300"></i>
                <div>
                    <p>Initiate Ride!</p>
                    <p>Booked a {{result.orderType}} service from {{result.pickupAddress}} to {{result.deliveryAddress}}</p>
                    <p class="text-green-600">{{result.status}}</p>
                </div>
                <p>{{moment(result.created_at).format("DD, ddd yy")}}</p>
            </div>
            <hr>

            
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import {baseUrl} from '../../../Config';
import moment from 'moment';
const url = baseUrl;
export default {
   data() {
        return {
            activity: [],
            id: localStorage.getItem("user-id"),
            results: [],
            token : localStorage.getItem("token"),
            display: ""
        }
    },

    mounted() {
        this.getActivity();
    },

    methods: {
        moment(date) {
            return moment(date);
        },
        getActivity() {
            let token = localStorage.getItem("token")
            axios({
                method: 'GET',
                url: `${url}/v1/web/riders/orders/${this.id}`,
                headers: {
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3',
                    Authorization: `Bearer ${token}`,

                },
            })
            .then((res) => {
                this.results = res.data.data.results
                if(this.results.length <= 0) {
                    this.display = "No activity performed."
                }
                console.log(this.results);
            }) 
            .catch((err) => {
                err;
            })
        }
    }
}
</script>